var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormulateInput',_vm._b({staticClass:"element",class:{
    'element--radio': _vm.as === 'radio',
    'element--checkbox': _vm.as !== 'radio',
  },attrs:{"validation-name":_vm.label,"label":_vm.elementLabel,"type":"checkbox"}},'FormulateInput',Object.assign({}, _vm.$props, _vm.$attrs),false))}
var staticRenderFns = []

export { render, staticRenderFns }